import React from 'react'

import { Tooltip } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, string } from 'prop-types'

import countVisibleExtensions from './countVisibleExtensions'

// "+N" sits inside the checkbox's <label>, so a click on it would also toggle the format. Stopping the
// click also keeps react-tooltip's global click-off from closing the tooltip it opens on narrow screens.
const handleMoreClick = (event) => {
  event.preventDefault()
  event.stopPropagation()
}

// A list too long for one line renders twice: whole and wrapping for touch screens, where a tap
// toggles the checkbox and nothing can hover "+N", and cut to "+N" for pointers (CSS picks one).
// The cut form keeps the hidden extensions for screen readers, so the row's name stays complete.
function Extensions({ name, extensions, tooltipId }) {
  const visibleCount = countVisibleExtensions(name, extensions)
  const list = extensions.join(', ')

  if (visibleCount === extensions.length) {
    return <span className="file-format-filter__extension">{`(${list})`}</span>
  }

  return (
    <>
      <span className="file-format-filter__extension file-format-filter__extension--full">{`(${list})`}</span>
      <span className="file-format-filter__extension file-format-filter__extension--compact">
        {`(${extensions.slice(0, visibleCount).join(', ')}`}
        <span className="file-format-filter__hidden-extensions">
          {`, ${extensions.slice(visibleCount).join(', ')}`}
        </span>
        <span aria-hidden="true">
          {' '}
          <Tooltip
            id={tooltipId}
            content={list}
            place="top"
            tooltipClassName="file-format-filter__tooltip"
          >
            <span className="file-format-filter__more" onClick={handleMoreClick}>
              {`+${extensions.length - visibleCount}`}
            </span>
          </Tooltip>
        </span>
        )
      </span>
    </>
  )
}

Extensions.propTypes = {
  name: string.isRequired,
  extensions: arrayOf(string).isRequired,
  tooltipId: string.isRequired,
}

export default Extensions
